export function normalizeUrl (str) {
  // make sure protocol is followed by two slashes
  str = str.replace(/:\//g, '://')

  // remove consecutive slashes
  str = str.replace(/([^:\s])\/+/g, '$1/')

  // remove trailing slash before parameters or hash
  str = str.replace(/\/(\?|&|#[^!])/g, '$1')

  // replace ? in parameters with &
  str = str.replace(/(\?.+)\?/g, '$1&')

  return str
}

export function join (...input) {
  for (let i = 0; i < input.length; i++) {
    if (Array.isArray(input[i])) {
      input = input[i]
      break
    }
  }

  let joined = [].slice.call(input, 0).join('/')

  return normalizeUrl(joined)
}



// WEBPACK FOOTER //
// ./src/lib/url-join.js